import React, { } from "react";
import ApexChart from "../../../Charts/ApexChart"
import RenderComponent from "../../../General/RenderComponent";
import { dynamicSort } from "../../../../utils/MainHelper";

function WhiteSpacePieChart({
    data,
    noData,
    upperCase = true
}) {
    const newData = [...data].sort(dynamicSort("-score", true));

    const sumScore = newData.reduce((sum, d) => {
        sum += d.score;
        return sum;
    }, 0);
    return (

        <div style={{ width: "100%", height: "100%" }} className="d-flex-col">
            <RenderComponent show={noData} isFullscreen>
                <ApexChart
                    type="donut"
                    width="99%"
                    style={{
                        height: "100%"
                    }}
                    options={{
                        theme: {
                            monochrome: {
                                enabled: true,
                                color: "#3A63AB",
                                shadeTo: "light",
                                shadeIntensity: 0.9
                            }
                        },
                        animations: {
                            enabled: false
                        },
                        plotOptions: {
                            pie: {
                                donut: {
                                    size: "30%"
                                }
                            }
                        },
                        colors: [function ({ seriesIndex, w }) {
                            if (newData[seriesIndex] && newData[seriesIndex].color) {
                                return newData[seriesIndex].color;
                            }
                            return w.globals.colors[seriesIndex];
                        }
                        ],
                        tooltip: {
                            enabled: true,
                            y: {
                                formatter: (e) => `${((e / sumScore) * 100).toFixed(2)}%`,
                                title: {
                                    formatter: (seriesName) => seriesName
                                }
                            }
                        },
                        chart: {
                            id: "orig-donut",
                            toolbar: {
                                show: false
                            },
                            animations: {
                                enabled: false
                            }
                        },
                        dataLabels: {
                            enabled: true,
                            offsetX: -10,
                            offsetY: -10,
                            formatter(val, { w, seriesIndex }) {
                                const scoreString = ", " + val.toFixed(2) + "%"
                                return w.config.labels[seriesIndex] + scoreString;
                            },
                            style: {
                                fontWeight: "normal",
                                colors: ["white"],
                                fontFamily: "arial"
                            },
                            background: {
                                enabled: true,
                                opacity: 1,
                                foreColor: "black",
                                padding: 5,
                                borderRadius: 1,
                                borderWidth: 1,
                                borderColor: "white"
                            }
                        },
                        legend: {
                            show: false
                        },
                        labels: newData.map((d) => (upperCase ? d.title.toLocaleUpperCase() : d.title))
                    }}
                    series={newData.map((d) => d.score)}
                />
            </RenderComponent>
        </div>
    );
}

export default WhiteSpacePieChart;
